import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    path,
    mergeDeepLeft,
    clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import TableAjax from '../../сomponents/TableAjax';
import ConfirmAction from '../../common/ConfirmAction';
import UpdateDurationPopup from "./updateDurationPopup";
import {fetchActivities, downloadReportExcel} from '../../api/reports';
import {deleteActivity, updateActivityDuration} from '../../api/checkIn';
import DatePicker from '../../common/DatePicker';
import fields from './field';
import moment from '../../config/custom-moment';
import Preloader from '../../common/Preloader';
import './style.css';
import CheckBox from "../../common/CheckBox";
import {deleteAllReports, finishedAllActivitiesOnWorkTimePage} from '../../actions/reports';


import { fetchDetailsWithoutProperty } from '../../api/dashboard';
import fieldsDashboard from '../Dashboard/fields';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import { durationToString } from '../../utils/date';
import { fetchWorkers } from '../../api/employees';
import {deleteObject} from "../../actions/objectToDelete";
import {changeModalState} from "../../actions/modal";

const TIME_RANGE_DATE_FORMAT = 'MM/DD/YYYY';
const DEFAULT_SORT = 'started_at|desc';

const DEFAULT_STATE = {
  itemsList: [],
  container: false,
  search: '',
  fields: clone(fields),
  loading: false,
  itemsCount: 0,
  itemsPerPage: 10,
  currentPage: 0,
  projectsFields: [],
  workerOptions: [],
  selectedFields: [],
  totalSpent: 0,
  sort: DEFAULT_SORT,
};


export class TimesheetSummary extends Component {

    constructor(props) {
        super(props);
        this.reloadData = this.reloadData.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.handleFormValueChange = this.handleFormValueChange.bind(this);
        this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.getFilters = this.getFilters.bind(this);
        this.getPaginationParams = this.getPaginationParams.bind(this);
        this.getAllParams = this.getAllParams.bind(this);
        this.getReportItems = this.getReportItems.bind(this);
        this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
        this.onSetField = this.onSetField.bind(this);
        this.setProjectFields = this.setProjectFields.bind(this);
        this.handleSort = this.handleSort.bind(this);

        this.state = DEFAULT_STATE;

        this.activeColumns = [];
        this.activeColumnNames = [];

        this.columns = [
            'firstname',
            'activity_name',
            'wo_number',
            'customer_name',
            'task_description',
            'started_at',
            'stopped_at',
            'duration'
        ];

        this.sortableColumns = [
          'firstname',
          'started_at',
          'stopped_at'
        ];

        this.columnNames = [
            'Worker',
            'Activity',
            'Work Order',
            'Customer',
            'Description',
            'Started',
            'Finished',
            'Time Spent',
        ];
    }

    componentDidMount() {
      const {deleteAllReports, list} = this.props;

      deleteAllReports();

      this.setState({ loading: true }, () => {
        list(this.getAllParams());
      });
    }

    reloadData() {
        this.props.list(this.getAllParams());
    }


  getPaginationParams() {
    return { per_page: this.state.itemsPerPage, page: this.state.currentPage + 1, length: -1 };
  }

  getAllParams() {
    return {
      ...this.getPaginationParams(),
      ...this.getFilters(),
    };
  }

    onSearch(text) {
        this.setState({
            search: text,
        }, this.reloadData);
    }

    onSetField(i, id, val) {
        const { projectsFields } = this.state;
        const newField = [...projectsFields];
        newField[i] = val;
        const selectedIds = [];
        for (let i = 0; i < newField.length; i++) {
            if (newField[i].value) {
                selectedIds.push(newField[i].id)
            }
        }
        this.setState({ selectedFields: selectedIds, projectsFields: [...newField] }, () => {
            // this.reloadArchive(true);
        })
    }

    onChangeCurrentPage(currentPage) {
      this.setState({ ...{currentPage}, ...{loading: true} }, () => {this.reloadData()});
    }

    onChangeItemsPerPage(e) {
        e.preventDefault();
        this.setState({
            itemsPerPage: e.target.value,
            loading: true,
        },() => {
            this.reloadData();
          });
        return false;
    }

    getFilters() {
        const filters = {};

        const dateFrom = this.state.fields['filter_date_from'].value;
        const dateTo = this.state.fields['filter_date_to'].value;
        const groupBy = this.state.fields['group_by'].value;

        if (!!this.state.search) {
            filters['search'] = this.state.search;
        }

        if (dateTo) {
            filters['date_end'] = moment(dateTo).format('YYYY-MM-DD');
        }

        if (dateFrom) {
            filters['date_start'] = moment(dateFrom).format('YYYY-MM-DD');
        }

        if (groupBy) {
            filters['group_by'] = groupBy;
        }

        filters['sort'] = this.state.sort;

        const { projectsFields } = this.state;
        const projectFilterFields = projectsFields.filter(field => field.type === 'lanes').map(field => field.id);

        if (projectFilterFields && projectFilterFields.length) {
            filters['project-id'] = projectFilterFields;
        }

        return filters;
    }

    componentWillReceiveProps(newProps) {
        const lanes = path(['dashboard', 'lanes'], newProps);

        if (this.state.projectsFields.length === 0 && lanes) {
            this.setProjectFields(lanes);
        }

      const loadedNewData = path(['reports', 'loadedNewData'], newProps);

      const { loading } = this.state;

      if (loadedNewData === true && loading === true) {
        this.setState({loading: false});
        this.props.finishLoading(false);
      }
    }

  setProjectFields(lanes) {
        let selectedIds = [];
        const projectFields = [fieldsDashboard.search, {
            label: 'Unassigned',
            placeholder: '',
            system: {
                name: '',
            },
            value: true,
            errors: [],
            type: 'lanes',
            id: 0,
            name: 'project_' + 0,
            rules: {
                title: '',
                required: false,
            }
        }];
        for (let i = 0; i < lanes.length; i++) {
            let currentField = {
                label: lanes[i].label,
                placeholder: '',
                system: {
                    name: '',
                },
                value: true,
                errors: [],
                id: lanes[i].id,
                type: 'lanes',
                name: 'project_' + lanes[i].id,
                rules: {
                    title: '',
                    required: false,
                }
            };

            selectedIds.push(lanes[i].id);

            projectFields.push(currentField);
        }
        this.setState({
            selectedFields: selectedIds,
            projectsFields: projectFields,
        });
    }

    handleSort(sortBy, sortDirection) {
      this.setState({ sort: `${sortBy}|${sortDirection}`, loading: true }, () => {this.reloadData()});
    }

    handleFormValueChange(field, newObject) {
      this.setState(this.changeFormValue(field, newObject));
    }

    changeFormValue(field, newObject) {
        let stateClone = clone(this.state);
        stateClone.fields[field] = newObject;

        if (field === 'time_range') {
            let dateStart = '';
            let dateEnd = '';

            switch (newObject.value) {
                case 'Today':
                    dateStart = moment().format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'Yesterday':
                    dateStart = moment().subtract(1, 'day').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().subtract(1, 'day').format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'This Week':
                    dateStart = moment().startOf('week').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'This Month':
                    dateStart = moment().startOf('month').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                default:
                    break;
            }

            stateClone.fields['filter_date_to'].value = dateEnd;
            stateClone.fields['filter_date_from'].value = dateStart;
        }

        return mergeDeepLeft(stateClone, this.state);
    }

    fixDataForTable(data) {
        return data.map(dataPoint => ({
            id: dataPoint.id,
            firstname: `${dataPoint.firstname}  ${dataPoint.lastname}`,
            activity_name: dataPoint.activity_name,
            wo_number: dataPoint.wo_number,
            customer_name: dataPoint.customer_name,
            task_description: dataPoint.task_description,
            started_at: dataPoint.started_at ? moment.unix(dataPoint.started_at).format('MM/DD/YYYY h:mma') : '',
            stopped_at: dataPoint.stopped_at ? moment.unix(dataPoint.stopped_at).format('MM/DD/YYYY h:mma') : '',
            duration: durationToString(dataPoint.duration)
        }));
    }

    applyFilter() {
        this.props.deleteAllReports();
        const groupBy = this.state.fields['group_by'].value;

        if (groupBy === 'work_order') {
          this.activeColumns = ['wo_number', 'task_description', 'customer_name', 'duration']
          this.activeColumnNames = ['WO Number', 'Task Description', 'Customer', 'Total Spent']
        } else if (groupBy === 'employee') {
          this.activeColumns = ['firstname', 'duration']
          this.activeColumnNames = ['Employee', 'Total Spent']
        } else if (groupBy === 'activity') {
          this.activeColumns = ['activity_name', 'duration']
          this.activeColumnNames = ['Activity', 'Total Spent']
        } else if (groupBy === 'customer') {
          this.activeColumns = ['customer_name', 'duration']
          this.activeColumnNames = ['Customer', 'Total Spent']
        } else {
          this.activeColumns = [];
          this.activeColumnNames = [];
        }

      this.setState({ loading: true, currentPage: 0}, () => {
        this.props.list(this.getAllParams());
      });

    }

    getReportItems() {
        const itemsList = path(['reports', 'activities', 'data'], this.props);

        const itemsCount = path(['reports', 'activities', 'total'], this.props);

        if (!itemsList) {
            return null;
        }

        const sortBy = this.state.sort.split('|');

        return (
            <TableAjax
                items={this.fixDataForTable(itemsList)}
                columns={this.activeColumns.length ? this.activeColumns : this.columns}
                columnNames={this.activeColumnNames.length ? this.activeColumnNames : this.columnNames}
                sortable={this.sortableColumns}
                itemsPerPage={this.state.itemsPerPage}
                itemsPerPageLabel={'Items Per Page'}
                itemsCount={itemsCount}
                hideSearch={true}
                search={this.state.search}
                currentPage={this.state.currentPage}
                onChangeCurrentPage={this.onChangeCurrentPage}
                onApplySearch={this.onSearch}
                searchPosition='left'
                onChangeItemsPerPage={this.onChangeItemsPerPage}
                onChangeSorting={this.handleSort}
                defaultSort={{
                  column: sortBy[0],
                  direction: sortBy[1]
                }}
            />
        );
    }

    getProjects() {
        const projects = [];
        for (let i = 0; i < this.state.projectsFields.length; i++) {

            if (this.state.projectsFields[i].type == 'lanes') {

                projects.push(
                    <div style={{
                        display: 'inline-block',
                        border: '1px solid rgba(0, 0, 0, 0.125)',
                        borderRadius: '4px',
                        padding: '5px',
                        marginRight: '5px',
                        marginBottom: '5px',
                    }}>
                        <CheckBox
                            customize={{
                                margin: '0',
                                paddingTop: '0',
                                paddingBottom: '0',
                            }}
                            key={i}
                            field={this.state.projectsFields[i]}
                            onChange={(e, val) => this.onSetField(i, this.state.projectsFields[i].id, val)}
                        />
                    </div>
                );
            }
        }
        return projects;
    }


    render() {
        const { loading } = this.state;

        const mainPart = loading ? <Preloader show={true} type={'circle'} /> : this.getReportItems();

        let linesPart = this.getProjects();

        const downloadExcel = (
            <button
                className="btn btn-rounded btn-icon ui-btn pull-right"
                style={{ borderRadius: '4px' }}
                onClick={() => this.props.downloadReport()}
            >
                <a>
                    <i className="fa fa-download"></i>
                    Report
                </a>
            </button>
        );

        return (
            <div style={{ paddingBottom: '25px' }}>
                <Breadcrumbs list={[
                    { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
                    { icon: 'account_balance_wallet', name: 'Reports' },
                    { icon: 'account_balance_wallet', name: 'Timesheet Summary' },
                ]} />
                <div className="card rounded">
                    <div className="card-header rounded-top">
                        Timesheet Summary
                    </div>
                    <div className="card-block">
                        <div className="clearfix mb-3">
                            {downloadExcel}
                            <button
                                className="btn btn-rounded btn-icon ui-btn pull-right"
                                onClick={this.applyFilter}
                                style={{ marginRight: '10px', borderRadius: '4px', }}
                            >
                                <i className="fa fa-filter"></i>
                                Apply filter
                            </button>
                        </div>
                        <div className="row">
                            <div className="col col-md-12">
                                <b>Projects:</b>
                            </div>
                        </div>

                        <div className="row" style={{ paddingBottom: 10 }}>
                            <div className="col col-md-12">
                                {linesPart}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col col-md-4">
                                <ReactSelectWrapper
                                    options={[
                                        {
                                          'label': '-- All --',
                                          'value': ''
                                        },
                                        {
                                            'label': 'Today',
                                            'value': 'Today'
                                        },
                                        {
                                            'label': 'This Week',
                                            'value': 'This Week'
                                        },
                                        {
                                            'label': 'This Month',
                                            'value': 'This Month'
                                        },
                                        {
                                            'label': 'Yesterday',
                                            'value': 'Yesterday'
                                        }
                                    ]}
                                    field={this.state.fields['time_range']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                            <div className="col col-md-4">
                                <DatePicker
                                    field={this.state.fields['filter_date_from']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                            <div className="col col-md-4">
                                <DatePicker
                                    field={this.state.fields['filter_date_to']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                          <div className="col col-md-4">
                            <ReactSelectWrapper
                              options={[
                                {
                                  'label': 'Work Order',
                                  'value': 'work_order'
                                },
                                {
                                  'label': 'Employee',
                                  'value': 'employee'
                                },
                                {
                                  'label': 'Activity',
                                  'value': 'activity'
                                },
                                {
                                  'label': 'Customer',
                                  'value': 'customer'
                                }
                              ]}
                              field={this.state.fields['group_by']}
                              onChange={this.handleFormValueChange}
                            />
                          </div>
                        </div>
                        {mainPart}
                        <ConfirmAction />
                    </div>
                </div>
                <ConfirmAction id={'deleteActivityById'} />
                <UpdateDurationPopup id={'updateDurationPopup'} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStages: () => {
            fetchDetailsWithoutProperty()(dispatch);
        },
        downloadReport: () => {
            downloadReportExcel('activities', 'Timesheet-Report.csv')(dispatch);
        },
        getWorkers: () => {
            fetchWorkers()(dispatch);
        },
        finishLoading: (data) => {
          dispatch(finishedAllActivitiesOnWorkTimePage(data))
        },
        list: (data) => {
            fetchActivities(data)(dispatch);
        },
        deleteAllReports: () => {
            dispatch(deleteAllReports())
        },
        handleObjectToDelete: (data) => {
          dispatch(deleteObject(data));
        },
        handleModalState: (data) => {
          dispatch(changeModalState(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetSummary);



// WEBPACK FOOTER //
// ./src/containers/Reports/timesheetSummary.js